import type { GenerationTask, TaskStatus } from './generation-task'
import { aiCapabilityLabels, aiTaskStatusLabels, TERMINAL_AI_TASK_STATUSES } from '@/shared/model/ai-enums'

export const taskStatusLabels = aiTaskStatusLabels
export const taskCapabilityLabels = aiCapabilityLabels

const terminalTaskStatuses: ReadonlySet<TaskStatus> = new Set(TERMINAL_AI_TASK_STATUSES)

export function isTerminalTaskStatus(status: TaskStatus) {
  return terminalTaskStatuses.has(status)
}

export function getTaskStatusColor(status: TaskStatus) {
  if (status === 'SUCCEEDED') return 'success'
  if (status === 'FAILED') return 'error'
  if (status === 'CANCELLED') return 'default'
  return 'processing'
}

export function getTaskProgressStatus(status: TaskStatus) {
  if (status === 'SUCCEEDED') return 'success'
  if (status === 'FAILED') return 'exception'
  if (status === 'CANCELLED') return 'normal'
  return 'active'
}

export function getTaskPrompt(task: Pick<GenerationTask, 'input' | 'taskNo'>) {
  return String(task.input?.prompt ?? task.input?.speechText ?? task.taskNo)
}

export function getTaskPreviewArtifact(task: Pick<GenerationTask, 'output'>) {
  return task.output?.artifacts.find((artifact) => artifact.previewUrl)
}
